<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title">Danh sách công ty</h4>
          </div>
          <div class="text-right">
            <div class="text-right">
              <el-button
                @click="fn_tableShowFormSearch()"
                type="info"
                round
                class="btn-default"
                >Ẩn/hiện tìm kiếm</el-button
              >
              <el-button
                v-if="fn_canCreateCompany()"
                @click="fn_handle('create')"
                class="btn-default pl-2"
                round
                >Thêm mới</el-button
              >
            </div>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-search mb-2 b-shadow">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
            >
              <b-card>
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="120px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="4">
                      <el-form-item label="Tên công ty">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['name.name_vi']"
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Người đại diện">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value['representative.name']
                          "
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="4">
                      <el-form-item label="Người liên hệ">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['contact.name']"
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Điện thoại">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value['phone_number.phone_number']
                          "
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Địa chỉ">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['address.address']"
                          clearable
                          placeholder=""
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Trạng thái">
                        <!-- <el-checkbox
                                                    v-model="mData.tableRules.dataSearch.value.disabled"
                                                >
                                                    Khóa
                                                </el-checkbox> -->
                        <el-select
                          v-model="mData.tableRules.dataSearch.value.disabled"
                          clearable
                          placeholder=""
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listTrangThaiKhoa"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mt-1 mb-0">
                    <el-button
                      round
                      native-type="submit"
                      @click="fn_tableSearch()"
                      class="btn-default"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <el-table
              class="company-list-table"
              :data="mData.tableRules.data"
              border
              @sort-change="fn_tableSortChange"
              style="width: 100%"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column
                type="selection"
                width="40"
                v-if="mData.tableRules.allowSelect"
              ></el-table-column>

              <el-table-column prop="" label="STT" width="45">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="account"
                label="Tài khoản"
                min-width="95"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="name.name_vi"
                label="Tên công ty"
                min-width="150"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="representative.name"
                label="Người đại diện"
                min-width="120"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="contact.name"
                label="Người liên hệ"
                min-width="120"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="address.address"
                label="Trụ sở chính"
                min-width="140"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="phone_number.phone_number"
                label="Điện thoại"
                min-width="100"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column label="Khóa" width="55" align="center">
                <template slot-scope="scope">
                  <el-checkbox
                    v-model="scope.row.disabled"
                    :disabled="!fn_canUpdateCompany()"
                    @change="fn_changeTrangThaiKhoa(scope.row.id, scope.row.disabled)"
                  ></el-checkbox>
                </template>
              </el-table-column>

              <el-table-column label="Thao tác" align="center" width="150">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    round
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="fas fa-info-circle"></i>
                  </el-button>
                  <el-button
                    v-if="fn_canUpdateCompany()"
                    size="mini"
                    plain
                    round
                    @click="fn_handle('update', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_update"
                    type="primary"
                  >
                    <i class="far fa-edit"></i>
                  </el-button>
                  <!-- <el-button
                    v-if="fn_canDeleteCompany(scope.row)"
                    size="mini"
                    plain
                    round
                    @click="fn_handle('delete', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_delete"
                    type="danger"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button> -->
                </template>
              </el-table-column>
<!-- 
<el-table-column label="Thao tác" align="center" width="150">
  <template slot-scope="scope">
    <div class="action-buttons">
      <el-button
        size="mini"
        plain
        round
        @click="fn_handle('detail', scope.$index, scope.row)"
        v-b-popover.hover.left="aLang.c_detail"
      >
        <i class="fas fa-info-circle"></i>
      </el-button>

      <el-button
        v-if="fn_canUpdateCompany()"
        size="mini"
        plain
        round
        @click="fn_handle('update', scope.$index, scope.row)"
        v-b-popover.hover.left="aLang.c_update"
        type="primary"
      >
        <i class="far fa-edit"></i>
      </el-button>

      <el-button
        v-if="fn_canDeleteCompany(scope.row.id)"
        size="mini"
        plain
        round
        @click="fn_handle('delete', scope.$index, scope.row)"
        v-b-popover.hover.left="aLang.c_delete"
        type="danger"
      >
        <i class="fas fa-trash-alt"></i>
      </el-button>
    </div>
  </template>
</el-table-column> -->
            </el-table>
            <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
              <div class="col-md-4">
                <div v-if="mData.tableRules.allowSelect">
                  {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
                </div>
              </div>
              <div class="col-md-8 text-right">
                <el-pagination
                  @size-change="fn_tableSizeChange"
                  @current-change="fn_tableCurentChange"
                  @prev-click="fn_tablePrevClick"
                  @next-click="fn_tableNextClick"
                  :page-sizes="mData.tableRules.lengthMenu"
                  :page-size="mData.tableRules.limit"
                  :current-page="mData.tableRules.page"
                  background
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="mData.tableRules.total"
                  :pager-count="5"
                ></el-pagination>
              </div>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
import CompanyModel from "../../../views/admin/Company/CompanyModel";
import CompanyApi from "../../../moduleApi/CompanyApi";
import ProvinceApi from "../../../moduleApi/ProvinceApi";
import DistrictApi from "../../../moduleApi/DistrictApi";
import CommuneApi from "../../../moduleApi/CommuneApi";
import UserApi from "../../../moduleApi/UserApi";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        data: [],
        moduleName: "Company", //requied
        currentCompany: MethodService.getCompanyInfo(),
        dialogFormImportNhanVien: false,
        tableRules: MethodService.copyObject(CompanyModel.tableRules),
        dataDefault: {
          listProvice: [],
          listDistrict: [],
          listCommune: [],
          listTrangThaiKhoa: DataService.listTrangThaiKhoa,
          listUser: [],
        },
      },
    };
  },

  methods: {
    fn_canCreateCompany() {
      return MethodService.checkHaveFeature("FT002") || MethodService.checkHaveFeature("FT2302");
    },
    fn_canUpdateCompany() {
      return MethodService.checkHaveFeature("FT003") || MethodService.checkHaveFeature("FT2303") || MethodService.checkHaveFeature("FT2302");
    },
      
    fn_canDeleteCompany(company) {
      if (!company) {
        return false;
      }
      const currentCompany = this.mData.currentCompany || {};
      const isCurrentCompany = String(currentCompany.id) === String(company.id);
      const hasDeleteCompanyPermission = MethodService.checkHaveFeature("FT004");
      const hasDeleteMemberCompanyPermission =
        MethodService.checkHaveFeature("FT2304") ||
        MethodService.checkHaveFeature("FT2305");
      const isMemberCompany = company.company_type === "COMPANY" || !!company.parent_company_id;
      return hasDeleteMemberCompanyPermission && isMemberCompany;
    },
    async fn_initDataDefault() {
      const provinceApiRes = await ProvinceApi.list({
        limit: 100,
      });
      this.mData.dataDefault.listProvice = provinceApiRes.result;
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }
      const currentUser = MethodService.getCurrentUser();
      dataFilter = await MethodService.applyScopeFilter(dataFilter, currentUser, true);
      let res = await CompanyApi.list(dataFilter);
      if (res.result) {
        let resData = await this.fn_changeData(res.result);
        this.mData.tableRules.data = resData;
        this.mData.tableRules.total = res.meta.total;
        this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
        if (
          this.mData.tableRules.offset == res.meta.total &&
          this.mData.tableRules.offset != 0
        ) {
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.page = 1;
          this.fn_initTable();
        }
      }
    },
    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      let userIds = MethodService.findListItemDifferent(resData, "id");
      const userApiRes = userIds.length
        ? await UserApi.list({
            limit: userIds.length,
            filters: "id:in:" + userIds.join(","),
          })
        : { result: [] };
      this.mData.dataDefault.listUser = userApiRes.result;
      resData.forEach((row) => {
        let UserName = this.mData.dataDefault.listUser.find((e) => {
          return e.id == row.id;
        });
        if (UserName && UserName.account) {
          row.account = UserName.account;
        } else {
          const abbreviationName = row.name && row.name.abbreviation_name;
          row.account = abbreviationName
            ? abbreviationName.toLowerCase() + "_admin"
            : "";
        }
      });
      return resData;
    },
    //event table
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules.showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },
    //search
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["name.name_vi"]) {
        this.mData.tableRules.dataSearch.value[
          "name.name_vi"
        ] = this.mData.tableRules.dataSearch.value["name.name_vi"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["representative.name"]) {
        this.mData.tableRules.dataSearch.value[
          "representative.name"
        ] = this.mData.tableRules.dataSearch.value["representative.name"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["contact.name"]) {
        this.mData.tableRules.dataSearch.value[
          "contact.name"
        ] = this.mData.tableRules.dataSearch.value["contact.name"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["phone_number.mobile_phone"]) {
        this.mData.tableRules.dataSearch.value[
          "phone_number.mobile_phone"
        ] = this.mData.tableRules.dataSearch.value["phone_number.mobile_phone"].trim();
      }
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.fn_initTable();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },
    async fn_changeTrangThaiKhoa(id, trangThai) {
      if (!this.fn_canUpdateCompany()) {
        window.toastr.warning("Bạn không có quyền cập nhật công ty");
        this.fn_initTable();
        return;
      }
      let data = { company_id: id}
      if (trangThai) {
        await CompanyApi.LockCompany(data)
      } else {
        await CompanyApi.UnLockCompany(data)
      }
    },
    async changeProvince(id) {
      this.mData.tableRules.dataSearch.value["address.district_id"] = "";
      this.mData.tableRules.dataSearch.value["address.commune_id"] = "";
      this.mData.dataDefault.listCommune = [];
      const districtApiRes = await DistrictApi.list({
        limit: 100,
        filters: "province_id=" + id,
      });
      this.mData.dataDefault.listDistrict = districtApiRes.result;
    },
    async changeDistrict(id) {
      this.mData.tableRules.dataSearch.value["address.commune_id"] = "";
      const communeApiRes = await CommuneApi.list({
        limit: 100,
        filters: "district_id=" + id,
      });
      this.mData.dataDefault.listCommune = communeApiRes.result;
    },
    fn_handle(type, scope, row) {
      if (type == "create") {
        if (!this.fn_canCreateCompany()) {
          window.toastr.warning("Bạn không có quyền tạo công ty");
          return;
        }
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-create",
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "update") {
        if (!this.fn_canUpdateCompany()) {
          window.toastr.warning("Bạn không có quyền cập nhật công ty");
          return;
        }
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        if (!this.fn_canDeleteCompany(row)) {
          window.toastr.warning("Bạn không có quyền xóa công ty");
          return;
        }
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },
    async fn_delete(id) {
      try {
        await CompanyApi.delete(id);
        this.fn_initTable();
        window.toastr.success("Xóa công ty thành công!");
      } catch (e) {
        if (e.detail) {
          window.toastr.error(e.detail);
        } else {
          window.toastr.error("Xóa công ty không thành công");
        }
      }
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }

      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        )
        let m1 = this.mData.tableRules.filters.match(/\$vn_text=([^&]*)(&|$)/);
        if (m1) {
          this.$set(this.mData.tableRules.dataSearch.value, 'name.name_vi', decodeURIComponent(m1[1]));
        }
      }
    },
  },
  async created() {
    await this.fn_hashUrl();
    await this.fn_initDataDefault();
    await this.fn_initTable();
  }
};
</script>
<style scoped>
::v-deep .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 5px;
}
::v-deep .company-list-table .el-table__body-wrapper {
  overflow-x: auto;
}
::v-deep .company-list-table .el-table__fixed,
::v-deep .company-list-table .el-table__fixed-right {
  height: 100% !important;
}
.action-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 6px;
}

.action-buttons .el-button {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>
